export default {
    state: {
      getMembersClass:{},   //获取app头部信息
    },
    getters:{
      getMembersClass: (state) => state.getMembersClass,
    },
    mutations: {
      // 保存app头部信息
      SET_MEMBERSCLASS: (state, data) => {
        state.getMembersClass = data
      },
    },
    actions: {
      setMembersClass: ({ commit }, data) => {
        commit('SET_MEMBERSCLASS', data)
      },
    },
  }
  